export default {"src":"/_next/static/media/logo-black.5788734f.svg","height":96,"width":551,"blurWidth":0,"blurHeight":0};